<template>
<div>
    <header class="header_sticky">
        <div  class="container-fluid">
            <div class="menu-toggle-button only-mobile" v-if="isAuthenticated" @click="toggleMenu">
                <i class="pe-7s-menu"></i>
            </div>
            <div id="logo_home">
                <h1>
                    <router-link tag="a" :to="'/'" >
                    Recetalia
                    </router-link>
                    <div class="flag-uy"></div>
                </h1>
            </div>
            <nav>

                <div class="d-flex">
                    
                    <router-link v-if="!hideCreatePrescriptionBtn" tag="a" to="{ path: '/' }" class="btn btn-primary">
                        Buscar Prescripción
                    </router-link>
                    <!-- <b-dropdown block  right variant="text" class="only-desktop user-dropdown" >
                        <template v-slot:button-content class="dropdown-user">
                            {{loggedPharmacy.name}} {{loggedPharmacy.lastname}}
                        </template>
                        <router-link tag="b-dropdown-item" to="/account">Mi perfil</router-link>
                        <router-link tag="b-dropdown-item" to="/settings">Configuraciones</router-link>
                        <router-link tag="b-dropdown-item" to="/logout">Salir</router-link>
                    </b-dropdown> -->


                </div>

                <!-- <ul id="top_access" v-if="isAuthenticated">
                    
                    <li id="user" >    
                        <span class="d-none d-md-block ">
                        {{loggedPharmacy.name}} {{loggedPharmacy.lastname}}
                        </span>
                    </li>
                    
                    <router-link tag="li" :to="`/prescriptions/create`" >    
                        <div class="btn btn-outline-secondary">
                            <i class="icon icon-plus"></i>
                        </div>
                    </router-link>
                </ul> -->
                <!-- <div class="main-menu"  v-if="!isAuthenticated">
                    <ul>
                        <li v-if="$route.name!='login'"><router-link tag="a" :to="'/login'">Ingresar</router-link></li>
                        <li v-if="$route.name!='register'"><router-link tag="a" :to="'/register'">Registrarme</router-link></li>
                    </ul>
                </div> -->
            </nav>
        </div>
    </header>
    <div class="header-separator"></div>
    
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: "Navigation",
    props:['hideCreatePrescriptionBtn'],
    computed: {
		...mapGetters(['isAuthenticated','loggedPharmacy'])
    },
    data(){
        return {
            API_URL: process.env.VUE_APP_API_URL,
        }
    },
    beforeMount(){
        // console.log(this.$route);
    },
    
    methods: {
        ...mapMutations(['toggleMenu'])
    },
};
</script>

<style scoped>
header {
    background-color: #fff;
    height: 62px;
    border-bottom: 1px solid transparent;
}

header.header_sticky {
    width: 100%;
    z-index: 999;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

header.header_sticky.sticky {
    border-bottom: 1px solid #ededed;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
}


.header_sticky .container-fluid{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 62px;
}

header.header_map {
    width: 100%;
    border-bottom: 1px solid #ededed;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
}

header.static {
    position: static;
    border-bottom: 1px solid #ededed;
    z-index: 999;
    position: relative;
}

ul#top_access {
    position: relative;
    margin: -1px 0 0 0;
    display: flex;
}


ul#top_access li {
    display: inline-block;
    position: relative;
    padding: 0;
    margin-left: 15px;
    display: flex;
}

ul#top_access li i {
    font-size: 34px;
    font-size: 2.125rem;
}

ul#top_access li a {
    color: #464646;
    display: flex;
    align-items: center;
}

ul#top_access li a:hover {
    color: #333;
}

ul#top_access li#user {
    position: relative;
    font-weight: 500;
    display: flex;
    align-items: center;
}

ul#top_access li#user figure {
    width: 35px;
    height: 35px;
    overflow: hidden;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    border-radius: 50%;
    margin:0px 6px;
}

ul#top_access li#user figure .avatar {
    width: auto;
    height: 35px;
}


#logo_home h1 {
    margin: 0;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
}

#logo_home h1 a {
    width: 270px;
    display: block;
    background: url(../../assets/img/logo.png) no-repeat 0 0;
    background-size: contain;
    text-indent: -9999px;
}

.menu-toggle-button{
    font-size: 2rem;
    margin-top: 6px;
}
.menu-toggle-button i{
    margin-left: -28px;
}

@media only screen and (min--moz-device-pixel-ratio: 2),
only screen and (-o-min-device-pixel-ratio: 2 / 1),
only screen and (-webkit-min-device-pixel-ratio: 2),
only screen and (min-device-pixel-ratio: 2) {
    #logo_home h1 a {
        width: 220px;
        margin-top: 10px;
    }
}

.header-separator{
    height: 64px;
    width:100%;

}

/* @media (max-width: 576px) {
    .menu-toggle-button{
        display: block;
    }
    .header_sticky{
        position: fixed !important;
    }
    .header-separator{
        display: block;
    }
} */

.main-menu {
    position: relative;
    z-index: 9;
    width: auto;
    top: 11px;
    float: right;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

.main-menu ul,
.main-menu ul li {
    position: relative;
    margin: 0;
    padding: 0;
}

.main-menu ul a,
.main-menu ul li a {
    position: relative;
    margin: 0;
    padding: 0;
    display: block;
    padding: 10px;
}

/*First level styles */
.main-menu>ul>li>a {
    color: #333;
    padding: 0 8px 17px 8px;
    font-size: 14px;
    font-size: 0.875rem;
    font-weight: 500;
}

.main-menu>ul>li:hover>a {
    color: #12bcec;
}

/* Menu */
.main-menu {
    position: relative;
    z-index: 9;
    width: auto;
    top: 11px;
    float: right;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

.main-menu ul,
.main-menu ul li {
    position: relative;
    margin: 0;
    padding: 0;
}

.main-menu ul a,
.main-menu ul li a {
    position: relative;
    margin: 0;
    padding: 0;
    display: block;
    padding: 10px;
}

/*First level styles */
.main-menu>ul>li>a {
    color: #333;
    padding: 0 8px 17px 8px;
    font-size: 14px;
    font-size: 0.875rem;
    font-weight: 500;
}

.main-menu>ul>li:hover>a {
    color: #12bcec;
}

/* Opacity mask when left open */
.layer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    min-width: 100%;
    z-index: 100;
    min-height: 100%;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.8);
    -webkit-transition: transform 0.3s ease 0s, opacity 0.3s ease 0s,
        visibility 0s ease 0.3s;
    -moz-transition: transform 0.3s ease 0s, opacity 0.3s ease 0s,
        visibility 0s ease 0.3s;
    -ms-transition: transform 0.3s ease 0s, opacity 0.3s ease 0s,
        visibility 0s ease 0.3s;
    -o-transition: transform 0.3s ease 0s, opacity 0.3s ease 0s,
        visibility 0s ease 0.3s;
    transition: transform 0.3s ease 0s, opacity 0.3s ease 0s,
        visibility 0s ease 0.3s;
    opacity: 0;
    visibility: hidden;
}

.layer-is-visible {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.3s ease 0s, transform 0.3s ease 0s;
    -moz-transition: opacity 0.3s ease 0s, transform 0.3s ease 0s;
    -ms-transition: opacity 0.3s ease 0s, transform 0.3s ease 0s;
    -o-transition: opacity 0.3s ease 0s, transform 0.3s ease 0s;
    transition: opacity 0.3s ease 0s, transform 0.3s ease 0s;
}

#close_in,
#header_menu,
.cmn-toggle-switch {
    display: none;
}

/* All styles for screen size over 992px
================================================== */
@media only screen and (min-width: 992px) {
    .main-menu {
        width: auto;
    }

    .main-menu a {
        white-space: nowrap;
    }

    .main-menu ul li {
        display: inline-block;
    }

    .main-menu ul li.submenu:hover>a:before,
    .main-menu ul li.submenu:hover>a:after {
        bottom: -10px;
        opacity: 0;
    }

    /* Submenu*/
    .main-menu ul ul,
    .main-menu ul li .menu-wrapper {
        position: absolute;
        border-top: 2px solid #12bcec;
        z-index: 1;
        visibility: hidden;
        left: 3px;
        top: 100%;
        margin: 0;
        display: block;
        padding: 0;
        background: #fff;
        min-width: 210px;
        -webkit-box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
        -moz-box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
        box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
        -webkit-transform: translateY(20px);
        -moz-transform: translateY(20px);
        -ms-transform: translateY(20px);
        -o-transform: translateY(20px);
        transform: translateY(20px);
        opacity: 0;
        -moz-transition: all 0.2s ease;
        -o-transition: all 0.2s ease;
        -webkit-transition: all 0.2s ease;
        -ms-transition: all 0.2s ease;
        transition: all 0.2s ease;
    }

    .main-menu ul li .menu-wrapper {
        padding: 10px 15px !important;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .main-menu ul li:hover>ul,
    .main-menu ul li:hover .menu-wrapper {
        padding: 0;
        visibility: visible;
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        -ms-transform: translateY(0);
        -o-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }

    .main-menu ul .menu-wrapper ul {
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        border-top: none;
        margin: 0;
        position: static;
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        -ms-transform: translateY(0);
        -o-transform: translateY(0);
        transform: translateY(0);
    }

    .main-menu ul .menu-wrapper ul:before {
        border: 0;
    }

    .main-menu ul ul li {
        display: block;
        height: auto;
        padding: 0;
    }

    .main-menu ul ul li a {
        font-size: 13px;
        font-size: 0.8125rem;
        color: #555;
        border-bottom: 1px solid #ededed;
        display: block;
        padding: 15px;
        -moz-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        -webkit-transition: all 0.3s ease;
        -ms-transition: all 0.3s ease;
        transition: all 0.3s ease;
    }

    .main-menu ul ul li:last-child a {
        border-bottom: none;
    }

    .main-menu ul ul li:hover>a {
        background-color: #f9f9f9;
        color: #12bcec;
        padding-left: 18px;
    }

    /* Submenu 3rd level v.1.4 */
    .main-menu ul ul ul {
        position: absolute;
        border-top: 0;
        z-index: 1;
        height: auto;
        left: 100%;
        top: 0;
        margin: 0;
        padding: 0;
        background: #fff;
        min-width: 190px;
        -webkit-box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
        -moz-box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
        box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
    }
}

@media only screen and (max-width: 991px) {

    .main-menu ul li a:hover,
    a.show-submenu:hover,
    a.show-submenu:focus,
    a.show-submenu-mega:hover,
    a.show-submenu-mega:focus {
        color: #12bcec !important;
        background-color: #f9f9f9;
    }

    .main-menu ul li {
        border-top: none;
        border-bottom: 1px solid #ededed;
        color: #fff;
    }

    /* Menu mobile first level */
    .main-menu ul li a {
        padding: 15px !important;
    }

    .main-menu li,
    .main-menu a {
        display: block;
        color: #333 !important;
    }

    .main-menu li {
        position: relative;
    }

    .main-menu a:hover {
        color: #12bcec !important;
    }

    .main-menu ul>li {
        padding-bottom: 0;
    }

    .main-menu ul>li i {
        float: right;
    }

    /* Menu mobile second level */
    .main-menu ul li.submenu ul {
        border-left: 1px solid #ededed;
        margin: 0 0 10px 25px;
    }

    .main-menu ul li.submenu ul li {
        border: 0;
    }

    /* Menu mobile 3rd level */
    .main-menu ul li.submenu ul ul {
        border-left: none;
        margin: 0 0 0 15px;
    }

    /* Menu mobile left panel */
    .main-menu {
        overflow-y: scroll;
        padding-bottom: 60px;
        transform: translateX(-102%);
        top: 57px;
        border-top: 1px solid #ededed;
        left: 0;
        bottom: 0;
        width: 55%;
        height: 100%;
        position: fixed;
        background-color: #fff;
        -webkit-transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
        -moz-transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
        -ms-transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
        -o-transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
        transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
    }

    .main-menu.show {
        transform: translateX(0);
    }

    .main-menu .show-submenu+ul,
    a.show-submenu-mega+.menu-wrapper {
        display: none;
        visibility: hidden;
    }

    a.show-submenu-mega+.menu-wrapper.show_mega,
    .main-menu a.show-submenu+ul.show_normal {
        display: block;
        visibility: visible;
    }

    /* Hamburger menu button*/
    .cmn-toggle-switch {
        position: relative;
        display: block;
        overflow: visible;
        position: absolute;
        top: 7px;
        right: 15px;
        margin: 0;
        padding: 0;
        width: 30px;
        height: 30px;
        font-size: 0;
        text-indent: -9999px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        box-shadow: none;
        border: none;
        cursor: pointer;
    }

    .cmn-toggle-switch:focus {
        outline: none;
    }

    .cmn-toggle-switch span {
        display: block;
        position: absolute;
        top: 10px;
        left: 0;
        right: 0;
        height: 2px;
        background: #333;
    }

    .cmn-toggle-switch span::before,
    .cmn-toggle-switch span::after {
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #333;
        content: "";
    }

    .cmn-toggle-switch span::before {
        top: -10px;
    }

    .cmn-toggle-switch span::after {
        bottom: -10px;
    }

    .cmn-toggle-switch__htx span::before,
    .cmn-toggle-switch__htx span::after {
        -webkit-transition-duration: 0.3s, 0.3s;
        transition-duration: 0.3s, 0.3s;
        -webkit-transition-delay: 0.3s, 0;
        transition-delay: 0.3s, 0;
    }

    .cmn-toggle-switch__htx span::before {
        -webkit-transition-property: top, -webkit-transform;
        transition-property: top, transform;
    }

    .cmn-toggle-switch__htx span::after {
        -webkit-transition-property: bottom, -webkit-transform;
        transition-property: bottom, transform;
    }

    /* active state, i.e. menu open */
    .cmn-toggle-switch__htx.active span {
        background: none !important;
    }

    .cmn-toggle-switch__htx.active span::before {
        top: 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .cmn-toggle-switch__htx.active span::after {
        bottom: 0;
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        transform: rotate(-45deg);
    }

    .cmn-toggle-switch__htx.active span::before,
    .cmn-toggle-switch__htx.active span::after {
        -webkit-transition-delay: 0, 0.3s;
        transition-delay: 0, 0.3s;
    }
}

@media only screen and (max-width: 480px) {
    .main-menu {
        width: 100%;
    }
}




.user-dropdown /deep/ .btn.dropdown-toggle{
	background-color: #fff;
	color: #000;
	display: flex;
	align-items: center;
	border:none;
	border-radius: 0px;
	font-size: 12px;
}

</style>
